import { RefDate } from "@tblabs/truffle";
import { StepData } from "../../Step/StepData";
import { UsageStepRawData } from "./UsageStepRawData";


export class UsageStepData extends StepData
{
    public Start = new RefDate();
    public End = new RefDate();

    constructor(raw: Partial<UsageStepRawData>)
    {
        super(raw);
     
        this.Start.value = new Date(raw.Start || 0);
        this.End.value = new Date(raw.End || 0);
    }
}
